import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export type DeltaPeriod = 'weekly' | 'monthly' | 'quarterly' | 'yearly';

interface DeltaPeriodSelectorProps {
  value: DeltaPeriod;
  onChange: (value: DeltaPeriod) => void;
}

export function DeltaPeriodSelector({ value, onChange }: DeltaPeriodSelectorProps) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(val) => val && onChange(val as DeltaPeriod)}
      className="bg-muted/50 rounded-lg p-1"
    >
      <ToggleGroupItem
        value="weekly"
        className="text-xs px-3 py-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        Week
      </ToggleGroupItem>
      <ToggleGroupItem
        value="monthly"
        className="text-xs px-3 py-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        Month
      </ToggleGroupItem>
      <ToggleGroupItem
        value="quarterly"
        className="text-xs px-3 py-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        Quarter
      </ToggleGroupItem>
      <ToggleGroupItem
        value="yearly"
        className="text-xs px-3 py-1.5 data-[state=on]:bg-primary data-[state=on]:text-primary-foreground"
      >
        Year
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
